function GetBasketItemsCallback(status, dt) {
    if (status) {
        $(".js-cart-items-wrapper").html(dt);
        CheckoutPlaceholderLoader();

        GenerateLocalLoading($(".js-shopping-cart-content"), "hide");
        RefreshOrderSummary(false);
    }
}
function SetDataLeyerPush(step) {

    var eventlabel = "";
    var steps = "";
    var ispush = false;
    if (step == "login") {

        eventlabel = "Step 2";
        steps = "2";
        ispush = true;
    }
    else if (step == "adres") {
        eventlabel = "Step 3";
        steps = "3";
        ispush = true;
    }
    else if (step == "cargo") {
        eventlabel = "Step 4";
        steps = "4";
        ispush = true;
    }
    else if (step == "odeme") {
        eventlabel = "Step 5";
        steps = "5";
        ispush = true;
    }

    //if (ispush) {
    //    window.dataLayer = window.dataLayer || [];

    //    try {
    //        dataLayer.push({
    //            "event": "ecCheckout",
    //            "eventCategory": "Enhanced Ecommerce",
    //            "eventAction": "Checkout",
    //            "eventLabel": eventlabel,
    //            "ecommerce": {
    //                "currencyCode": "TRY",
    //                "checkout": {
    //                    "actionField": {
    //                        "step": steps
    //                    },
    //                    "products": ""
    //                }
    //            }
    //        });
    //    } catch (e) {

    //    }
    //}

}


function SetStepHandler(status, dt) {
    if (status) {
        if (dt.StatusText == "login") {
            GenerateLocalLoading($("body"), "show");
            document.location.href = getRequestRoute() + "/p/CheckOut";
        }
        else if (dt.StatusText == "progress") {
            GenerateLocalLoading($("body"), "show");
            document.location.href = getRequestRoute() + "/p/CheckOut/" + dt.StatusText;
        }
        else if (dt.StatusText == "progress-adyen") {
            SetProgress(SetProgressHandler);
        }
        else {
            if (dt.StatusText == "contactdetails") {
                setTimeout(function () {
                    InitContactDetails(InitContactDetailsHandler);
                }, 300);
            }
            if (dt.StatusText == "adres") {
                setTimeout(function () {
                    InitAddress(InitAddressHandler);
                }, 300);
            }
            else if (dt.StatusText == "odeme") {
                setTimeout(function () {
                    InitPayment(InitPaymentHandler);
                }, 300);
            }
        }
    }
    else {
        if (dt.StatusText == "AskForLogin") {
            GenerateLocalLoading($("body"), "show");
            document.location.href = getRequestRoute() + "/p/CheckOut";
        }
        //else if (dt.StatusText == "MissingAddress" || dt.StatusText == "InvalidAddress") {
        //    SwalGenerate("error", dt.ResultDescription, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
        //}
        else {
            SwalGenerate("error", dt.ResultDescription, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
        }
    }
}

function PartialAddressHandler(status, data, isBilling, item) {
    if (status) {
        if (item) {
            $(".js-address-dropdown .filter-name").text(item.text());
            $(".js-address-item").removeClass("current");
            item.addClass("current");
        }

        if (isBilling)
            $(".js-billing-address-form").html(data);
        else
            $(".js-address-form").html(data);
    }
    else {
        SwalGenerate("error", data, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
    }
}

function InitContactDetailsHandler(data) {
    $(".js-contactdetails-body-step-content").html(data);

    $(".js-payment-step").removeClass("current");
    $(".js-payment-step").slice(1).removeClass("finished");

    $(".js-payment-step[data-step='Login']").addClass("finished");
    $(".js-payment-step[data-step='ContactDetails']").addClass("current");

    ContactDetailsValidationForm();
    RefreshOrderSummary(false);
}

function InitAddressHandler(data) {
    $(".js-address-body-step-content").html(data);

    $(".js-payment-step").removeClass("current");
    $(".js-payment-step").slice(2).removeClass("finished");

    $(".js-payment-step[data-step='ContactDetails']").addClass("finished");
    $(".js-payment-step[data-step='Adres']").addClass("current");

    RefreshOrderSummary(false);
    GetOrderInformation(GetOrderInformationHandler);
}

function InitPaymentHandler(data) {
    if (!data) {
        SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
        return;
    }

    $(".js-payment-body-step-content").html(data);

    $(".js-payment-step").removeClass("current");
    $(".js-payment-step").slice(3).removeClass("finished");

    $(".js-payment-step[data-step='Adres']").addClass("finished");
    $(".js-payment-step[data-step='Odeme']").addClass("current");

    RefreshOrderSummary(false);
    GetOrderInformation(GetOrderInformationHandler);
}

function SetPaymentTypeHandler(status, data) {
    if (status) {
        RefreshOrderSummary(false);
    }
    else {
        SwalGenerate("error", data, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
    }
}

function ShowInstalmentHandler(bankCode, cardType, CardName, installmentCount, prizeType) {


    //const paytrValidCardTypes = ['advantage', 'axess', 'combo', 'bonus', 'cardfinans', 'maximum', 'paraf', 'world'];
    //var isValidtoInstallmentcardTypeForPaytr = prizeType != undefined && prizeType != null;// && paytrValidCardTypes.includes(prizeType);

    if (bankCode > 0 && cardType != undefined/* && isValidtoInstallmentcardTypeForPaytr*/) {
        cardType = cardType.toLowerCase();
        var isAmex = false;
        var isShopAndMiles = false;

        if (CardName != null && CardName != "" && CardName != undefined && CardName.length > 0) {
            if (CardName.toUpperCase().indexOf("AMEX") > -1) {
                isAmex = true;
            }

            if (CardName.toUpperCase().indexOf("MASTER SM") > -1 || CardName.toUpperCase().indexOf("VISA SM") > -1) {
                isShopAndMiles = true;
            }
        }

        if (isAmex || isShopAndMiles) bankCode = "64"; //burda hangi banka gelmeli belirlenmeli

        var InstallmentRows = $(".js-instalment-table tbody tr");
        InstallmentRows.removeClass("IsPasive").removeClass("IsActive").addClass("IsPasive");

        // Banka kartı tek çekim olarak gösterilecektir.
        if (cardType == "debit" || (cardType == "credit" && installmentCount == 1)) {
            InstallmentRows.removeClass("IsActive");
            InstallmentRows.addClass("IsPasive");

            $(".js-instalment-table .DefaultInstallment").removeClass("IsPasive");
            $(".js-instalment-table .DefaultInstallment").addClass("IsActive");

            //InstallmentRows.removeClass("current-instalment");
            //InstallmentRows.first().addClass("current-instalment").trigger("click");
        }
        else if (cardType == "credit") {
            // Kredi kartı tüm taksitleri gösterecek.
            InstallmentRows.removeClass("IsPasive");
            InstallmentRows.addClass("IsActive");

            //InstallmentRows.removeClass("current-instalment");
            //InstallmentRows.first().addClass("current-instalment").trigger("click");
        }
        else if ($(".js-card-owner").val() == "BÜTÜN POSLAR") {
            InstallmentRows.removeClass("IsPasive");
            InstallmentRows.addClass("IsActive");

            //InstallmentRows.removeClass("current-instalment");
            //InstallmentRows.first().addClass("current-instalment").trigger("click");
        }
        else {
            // Herhangi bir durumda default pos taksit (Tek çekim) gösterilecektir.
            InstallmentRows.removeClass("IsActive");
            InstallmentRows.addClass("IsPasive");

            $(".js-instalment-table .DefaultInstallment").removeClass("IsPasive");
            $(".js-instalment-table .DefaultInstallment").addClass("IsActive");

            //InstallmentRows.removeClass("current-instalment");
            //InstallmentRows.first().addClass("current-instalment").trigger("click");
        }
    }
    else {
        var InstallmentRows = $(".js-instalment-table tbody tr");
        InstallmentRows.removeClass("IsPasive").removeClass("IsActive").addClass("IsPasive");

        $(".js-instalment-table .DefaultInstallment").removeClass("IsPasive");
        $(".js-instalment-table .DefaultInstallment").addClass("IsActive");
    }
}

function SetCreditCartAndStepHandler(status, dt, adim) {
    if (status) {
        SetStep(adim, SetStepHandler);
    }
    else {
        dt.ResultDescription.forEach(function (item) {
            SwalGenerate("error", item, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
        });
    }
}

function SetProgressHandler(status, dt) {
    if (status) {
        window.checkOutStateAfterOrderCreated = dt;
        
        window.adyenDropinObject.submit(); // Adyen ödeme isteğinin yapılması
    }
    else {
        SwalGenerate("error", dt, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
    }
}

function GetOrderInformationHandler(status, data) {
    if (status) {

        if (data.JsonRs == null || data.JsonRs.length == 0)
            return null;

        var ContactDetails = data.JsonRs[0].ContactDetails;
        var DeliveryDetails = data.JsonRs[1].DeliveryAddress;
        var BillingDetails = data.JsonRs[2].BillingAddress;
        var CargoDetails = data.JsonRs[3].Cargo;

        if (ContactDetails) {
            $(".js-contactdetails-email").text(ContactDetails.Email);
            $(".js-contactdetails-phone").text(ContactDetails.TelephoneCode + " " + ContactDetails.Phone);
        }
        if (CargoDetails) {
            $(".js-delivery-method").text(CargoDetails.Name);
        }
        if (DeliveryDetails) {
            $(".js-delivery-name").text(DeliveryDetails.Name);
            $(".js-delivery-phone").text(DeliveryDetails.Phone);
            $(".js-delivery-detail").text(DeliveryDetails.Detail);

            if (DeliveryDetails.State)
                $(".js-delivery-city").text(DeliveryDetails.State + " / " + DeliveryDetails.City);
            else
                $(".js-delivery-city").text(DeliveryDetails.City);
        }
        if (BillingDetails) {
            $(".js-billing-name").text(BillingDetails.Name);
            $(".js-billing-phone").text(BillingDetails.Phone);
            $(".js-billing-detail").text(BillingDetails.Detail);

            if (BillingDetails.State)
                $(".js-billing-city").text(BillingDetails.State + " / " + BillingDetails.City);
            else
                $(".js-billing-city").text(BillingDetails.City);
        }



        return;

        var AddressDetail = data.JsonRs[1].DeliveryAddress;

        if (AddressDetail) {
            var Name = $(".js-payment-step[data-step='Adres'] .js-step-information-name");
            var Detail = $(".js-payment-step[data-step='Adres'] .js-step-information-detail");
            var Phone = $(".js-payment-step[data-step='Adres'] .js-step-information-phone");

            if (AddressDetail.Name)
                Name.text(AddressDetail.Name);
            else
                Name.text("");

            if (AddressDetail.Detail)
                Detail.text(AddressDetail.Detail);
            else
                Detail.text("");

            if (AddressDetail.Phone)
                Phone.text(AddressDetail.Phone);
            else
                Phone.text("");
        }

        if (data.JsonRs.length <= 1)
            return null;

        var CargoDetail = data.JsonRs[2].Cargo;

        if (CargoDetail) {
            var CargoName = $(".js-payment-step[data-step='Cargo'] .js-step-information-name");

            if (CargoDetail.Name)
                CargoName.text(CargoDetail.Name);
            else
                CargoName.text("");
        }

        if (data.JsonRs.length <= 2)
            return null;
    }
}